var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pilots"},[_c('el-row',{attrs:{"gutter":10}},[_c('el-col',{attrs:{"span":24,"md":12}},[_c('PilotListing')],1),_c('el-col',{attrs:{"span":24,"md":12}},[_c('TugBoatListing')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }